import { render, staticRenderFns } from "./detailsRedEnvelopeRain.vue?vue&type=template&id=74a2fc1f&scoped=true&"
import script from "./detailsRedEnvelopeRain.vue?vue&type=script&lang=js&"
export * from "./detailsRedEnvelopeRain.vue?vue&type=script&lang=js&"
import style0 from "./detailsRedEnvelopeRain.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailsRedEnvelopeRain.vue?vue&type=style&index=1&id=74a2fc1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2fc1f",
  null
  
)

component.options.__file = "detailsRedEnvelopeRain.vue"
export default component.exports